/** @format */
import { makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import TariffAdd from './TariffAdd';
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import { useParams } from 'react-router-dom';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { tariffConstants } from '../../../modules/tariffs/actions';
import { configDefault } from '../../../core/config';
import { useDispatch } from 'react-redux';
import GridContainer from '../../../components/Grid/GridContainer';
import TariffInterface from '../../../interfaces/billing/TariffInterface';
import Card from '../../../components/Card/Card';
import CardHeader from '../../../components/Heading/CardHeaderExt';
import CardBody from '../../../components/Card/CardBody';
import { LinearBillingList } from '../../PricelistReforged/LinearBillingList';

export const TariffEdit = (): React.ReactElement => {
    const { id } = useParams();
    const dispatch = useDispatch();

    const URI = '/tariffs';

    const [tariff, setTariff] = useState<TariffInterface | null>(null);

    useEffect(() => {
        if (id) {
            const itemLoaders = new ItemLoaders(dispatch);
            itemLoaders.getWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath(`${URI}/${id}`, configDefault.PLATFORM_API_PREFIX)),
                tariffConstants.ITEM,
                (data: any) => {
                    setTariff(data);
                },
                {
                    propagateDataToCallback: true,
                    dispatchAfterCallback: false,
                }
            );
        }
    }, [dispatch, id]);

    if (tariff) {
        return (
            <GridContainer>
                <Card>
                    <CardHeader trans={'tariffs:t.tariff_edit'} />
                </Card>
                <CardBody>
                    <TariffAdd tariff={tariff} editMode={true} />
                    <LinearBillingList tariff={tariff} />
                </CardBody>
            </GridContainer>
        );
    } else {
        // TODO: Add handler for no item
        return <div>Ładowanie</div>;
    }
};
